import React from 'react';
import { Paper, Grid2, PaperProps } from '@mui/material';

interface DoublePaperProps {
  /** Вес (доля ширины) для первой панели */
  w1: number;
  /** Вес (доля ширины) для второй панели */
  w2: number;
  /** Пропсы для первого Paper (опционально) */
  paper1Props?: PaperProps;
  /** Пропсы для второго Paper (опционально) */
  paper2Props?: PaperProps;
  /** Контент для панелей */
  children: [React.ReactNode, React.ReactNode];
}

const DoublePaper: React.FC<DoublePaperProps> = ({ 
  w1, 
  w2, 
  paper1Props, 
  paper2Props, 
  children 
}) => {
  return (
    <Grid2 container spacing={2} sx={{ width: '100%', p: 0 }} >
      {/* Левая панель */}
      <Grid2 size={{ xs: 12, md: (w1 / (w1 + w2)) * 12 }}>
        <Paper 
          elevation={3} 
          sx={{ p: 2, height: '100%' }} 
          {...paper1Props}
        >
          {children[0]}
        </Paper>
      </Grid2>

      {/* Правая панель */}
      <Grid2 size={{ xs: 12, md: (w2 / (w1 + w2)) * 12 }}>
        <Paper 
          elevation={3} 
          sx={{ p: 2, height: '100%' }} 
          {...paper2Props}
        >
          {children[1]}
        </Paper>
      </Grid2>
    </Grid2>
  );
};

export default DoublePaper;